<template>
  <div class="integralRedPacket b_white">
    <div v-if="show">
      <div class="box50"></div>
      <div class="t_center f20_rem gray_3">恭喜您，{{userFetchPoints}}{{giveResult.pointsRuleVo.name}}已到账！</div>
      <div class="box50"></div>
      <div class="padd_15">
        <div class="gray_3 f16_rem mar20_b">可用商品</div>
        <div class="border_radius_10 b_white mar15_b">
          <goodTemplate1 :goodsList="goodsList" />
        </div>
        <div class="mar15_b t_center red" @click="toShopHome"> 更多> </div>
      </div>
    </div>
    <!-- eslint-disable-next-line -->
    <van-popup v-model:show="popupShow" :close-on-click-overlay="false" class="redPacket">
      <div class="main">
        <div class="title">{{giveResult.boName}}发出的{{giveResult.pointsRuleVo.name}}红包</div>
        <template v-if="giveResult.fetchStatus === 1">
          <div class="content">
            <span>您已领取过该{{giveResult.pointsRuleVo.name}}</span>
          </div>
          <div class="btn" @click="toShopHome">去使用</div>
        </template>
        <template v-else-if="giveResult.fetchStatus === 2">
          <div class="content">
            <span>晚来一步，积分包已被抢光啦</span>
          </div>
        </template>
        <template v-else-if="giveResult.fetchStatus === 3">
          <div class="content">
            <span>您来晚了，该赠送已失效</span>
          </div>
        </template>
        <template v-else-if="giveResult.fetchStatus === 4">
          <div class="content">
            <span>专属包只有专属的人可领取呢</span>
          </div>
        </template>
        <template v-else>
          <div class="content">
            <span></span>
          </div>
          <div class="btn" v-if="isLoaded" @click="fetchGiveReq">点击领取</div>
        </template>
      </div>
    </van-popup>
  </div>
</template>
<script>

import { mapState } from "vuex";
import { Toast } from "vant";
import common from "@/assets/js/common";
import goodTemplate1 from "@/components/goodList/template1";

export default {
  components: {
    goodTemplate1
  },
  data() {
    return {
      isLoaded: false,
      show: false,
      popupShow: false,
      isRegister: false,
      goodsList: [],
      shopId: "",
      giveId: "",
      giveResult: {
        pointsRuleVo: {},
        fetchStatus: 0
      },
      userFetchPoints: "",
      wxHtml: "",
      url_r: "/api/mod/share.do",
      isMiniProgram: false
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    this.$nextTick(() => {
      this.popupShow = true;
    });
    this.shopId = this.$route.query.shopId;
    this.giveId = this.$route.query.giveId;
    this.getGivePoints();

    if (common.isInWeiXin()) {
      const ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == "micromessenger"){//eslint-disable-line
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            // 小程序
            if (this.shopId === "6340867391440003296" || this.shopId === "6999867391440009601" || this.shopId === "6340867391440008896") {
              this.isMiniProgram = true;
            } else {
              this.isMiniProgram = false;
            }
          } else {
            this.isMiniProgram = false;
          }
        });
      }
    } else {
      this.isMiniProgram = false;
    }
  },
  methods: {
    getGivePoints() {
      const params = {
        giveId: this.giveId
      };
      this.$store.dispatch("shop/shopPoints/getGivePoints", params).then((data) => {
        this.isLoaded = true;
        if (data.code !== "0") {
          Toast(data.msg);
          return;
        }
        this.giveResult = data.data || {};
        this.userFetchPoints = this.giveResult.userFetchPoints;
      }).catch(() => {
      });
    },
    fetchGiveReq() {
      // 校验登录
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      const params = {
        giveId: this.giveId
      };
      this.$store.dispatch("shop/shopPoints/fetchGiveReq", params).then((data) => {
        if (data.code !== "0") {
          Toast(data.msg);
          // 已领取
          if (data.code === "426006") {
            this.$set(this.giveResult, "fetchStatus", 1);
          }
          // 已领完
          if (data.code === "426007") {
            this.$set(this.giveResult, "fetchStatus", 2);
          }
          // 已失效
          if (data.code === "426008") {
            this.$set(this.giveResult, "fetchStatus", 3);
          }
          return;
        }
        Toast("领取成功");
        this.getShopIndex();
        setTimeout(() => {
          this.userFetchPoints = data.data || {};
          this.popupShow = false;
          this.show = true;
        }, 800);
      }).catch(() => {
      });
    },
    // 分类
    getShopIndex() {
      const param = {
        shopId: this.shopId
      };
      this.$store.dispatch("shop/shopDetails/shopIndex", this.$qs.stringify(param)).then((data) => {
        Toast.clear();
        if (data) {
          this.goodsList = this.goodsFieldHandle(data.goodsList);
          // const promotionGoods = this.goodsFieldHandle(data.promotionGoods);
        }
      });
    },
    goodsFieldHandle(goodsList) {
      const promotionMap = {
        DIRECT_SELLING: "直降", DISCOUNT: "折扣", BUY_GIFTS: "买赠", GROUP_PURCHASE: "集采"
      };
      const newGoodsList = [];
      if (goodsList && goodsList.length > 0) {
        goodsList.forEach((goods) => {
          newGoodsList.push({
            goodsId: goods.goodsId,
            picUrl: goods.picUrl ? goods.picUrl : goods.imgUrl,
            isSelfOperated: goods.isSelfOperated,
            isOptimization: goods.isOptimization,
            name: goods.name,
            sellFactPrice: goods.promotionPrice,
            sellPrice: goods.marketPriceStr ? goods.marketPriceStr : goods.price,
            isVip: goods.isVip,
            coupRegularResList: goods.coupRegularResList,
            promotionType: goods.promotionType,
            promotionTypeCN: goods.promotionType ? promotionMap[goods.promotionType] : "",
            isOthersGoodsReceipt: goods.shopDtlEntity ? goods.shopDtlEntity.isOthersGoodsReceipt : 0,
            isPrescription: goods.isPrescription,
            shopName: goods.shopName,
            shopIds: this.shopId
          });
        });
      }
      return newGoodsList;
    },
    // 跳转店铺首页
    toShopHome() {
      if (this.isMiniProgram) {
        // eslint-disable-next-line
        wx.miniProgram.switchTab({ url:'/pages/index/index' });
      } else {
        window.location.href = `${process.env.VUE_APP_APP}vm/shop/${this.giveResult.shopId}`;
      }
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
